import React from 'react';
import PostCard from '../../components/PostCard/PostCard';

export default function Home({ posts = [], loggedInUser, onDelete }) {
  const emptyClass = posts.length === 0 ? 'page-empty' : '';
  return (
    <div className={emptyClass}>
      <h2>首页</h2>
      {posts.length === 0 ? (
        <p>还没有文章。</p>
      ) : (
        <div className="article-list">
          {posts.map((p) => (
            <PostCard key={p.id} post={p} actions={null} />
          ))}
        </div>
      )}
    </div>
  );
}
